import helper from "./helper";

// export const uploadUrl = "/oil/app/file/uploadFile";
export const uploadUrl =
  "/api/blade-resource/oss/endpoint/put-file?code=ali-oss-p";

// export const adminUploadUrl = "/oil/admin/file/uploadFile";
export const adminUploadUrl =
  "/api/blade-resource/oss/endpoint/put-file?code=ali-oss-p";

export const uploadFile = function(path, file) {
  if (path instanceof FormData) {
    return helper.upload(uploadUrl, path);
  }
  const form = new FormData();
  if (file instanceof Blob) {
    form.append("file", file, "pic.png");
  } else {
    form.append("file", file);
  }
  form.append("path", path);
  return helper.upload(uploadUrl, form);
};

export const adminUploadFile = function(path, file) {
  if (path instanceof FormData) {
    return helper.upload(adminUploadUrl, path);
  }
  const form = new FormData();
  if (file instanceof Blob) {
    form.append("file", file, "pic.png");
  } else {
    form.append("file", file);
  }
  form.append("path", path);
  return helper.upload(adminUploadUrl, form);
};
